"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardHeaderStyled = exports.ContactCardHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _typography = require("../../typography");
var _contactCardTheme = require("../contactCardTheme");
const ContactCardHeaderStyled = (0, _styled.default)(_typography.TypeRampV2)`
    margin-bottom: ${_designTokens.space.space30};
`;
exports.ContactCardHeaderStyled = ContactCardHeaderStyled;
const ContactCardHeader = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const typeRampVariantProps = _contactCardTheme.contactCardTypeRampVariants.cardHeader[themeMode];
  return /*#__PURE__*/_react.default.createElement(ContactCardHeaderStyled, (0, _extends2.default)({}, rest, typeRampVariantProps), children);
};
exports.ContactCardHeader = ContactCardHeader;
//# sourceMappingURL=ContactCardHeader.js.map